import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const uicApi = `${process.env.VUE_APP_URL_PROTOCOL}://${process.env.VUE_APP_API_URL}/wp-json`;

const allPosts = '&filter[posts_per_page]=-1';

const routes = {
  uicMenu: `${uicApi}/menus`,
  uicAcf: `${uicApi}/acf_options`,
  uicMedia: `${uicApi}/media`,
  postTypeSpotlight: `${uicApi}/posts?type=spotlight${allPosts}`,
  postTypeKeyMessage: `${uicApi}/posts?type=key_message${allPosts}`,
  postTypeLandingPage: `${uicApi}/posts?type=landing_page${allPosts}`,
  // postTypeCampusGridPiece: `${uicApi}/posts?type=campus_grid_piece${allPosts}`,
  postTypeHomeIntro: `${uicApi}/posts?type=home_intro${allPosts}`,
  postTypeAcademicDates: `${uicApi}/academic-dates/upcoming`,
  postTypeReminder: `${uicApi}/posts?type=reminder${allPosts}`,
  postTypePage: `${uicApi}/posts?type=page${allPosts}`,
  postTypeFastFact: `${uicApi}/posts?type=fast_fact${allPosts}`,
  postTypeToday: `${uicApi}/posts?type=today${allPosts}`,
};

const routeCount = Object.keys(routes).length;

export default new Vuex.Store({
  state: {
    uic: null,
    menus: null,
    acf: null,
    media: null,
    spotlight: null,
    keyMessage: null,
    landingPage: null,
    // campusGridPiece: null,
    academicDates: null,
    homeIntro: null,
    reminder: null,
    page: null,
    fastFacts: null,
    today: null,
    todayNews: null,
    todayEvents: null,
    connectedApi: false,
    loadedApi: 0,
    apiCount: routeCount,
    loadedPages: 0,
    todayLoading: 0,
    errored: false,
    todayNewsErrored: false,
    todayEventsErrored: false,
  },
  mutations: {
    updateUIC(state, uic) {
      state.uic = uic;
    },
    updateMenus(state, menus) {
      state.menus = menus;
    },
    updateAcf(state, acf) {
      state.acf = acf;
    },
    updateMedia(state, media) {
      state.media = media;
    },
    updateKeyMessage(state, keyMessage) {
      state.keyMessage = keyMessage;
    },
    updateSpotlight(state, spotlight) {
      state.spotlight = spotlight;
    },
    updateLandingPage(state, landingPage) {
      state.landingPage = landingPage;
    },
    // updateCampusGridPiece(state, campusGridPiece) {
    //   state.campusGridPiece = campusGridPiece;
    // },
    updateAcademicDates(state, academicDates) {
      state.academicDates = academicDates;
    },
    updateReminder(state, reminder) {
      state.reminder = reminder;
    },
    updateFastFacts(state, fastFacts) {
      state.fastFacts = fastFacts;
    },
    updateHomeIntro(state, homeIntro) {
      state.homeIntro = homeIntro;
    },
    updatePage(state, page) {
      state.page = page;
    },
    updateNews(state, todayNews) {
      state.todayNews = todayNews;
    },
    updateEvents(state, todayEvents) {
      state.todayEvents = todayEvents;
    },
    updateToday(state, today) {
      state.today = today;
    },
  },
  actions: {
    getApi({ commit }) {
      axios.get(uicApi)
        .then((response) => {
          commit('updateUIC', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.connectedApi = true;
        });
      axios.get(routes.uicMenu)
        .then((response) => {
          commit('updateMenus', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.uicAcf)
        .then((response) => {
          commit('updateAcf', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      // Today News
      axios.get(routes.uicAcf)
        .then((response) => axios.get(response.data.uic_home.news_json_url))
        .then((response) => {
          commit('updateNews', response.data);
        })
        .catch((error) => {
          this.state.todayNewsErrored = true;
        })
        .finally(() => {
          this.state.todayLoading += 1;
        });
      // Today Events
      axios.get(routes.uicAcf)
        .then((response) => axios.get(response.data.uic_home.events_ical_url))
        .then((response) => {
          commit('updateEvents', response.data);
        })
        .catch((error) => {
          this.state.todayEventsErrored = true;
        })
        .finally(() => {
          this.state.todayLoading += 1;
        });
      axios.get(routes.uicMedia)
        .then((response) => {
          commit('updateMedia', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeKeyMessage)
        .then((response) => {
          commit('updateKeyMessage', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeSpotlight)
        .then((response) => {
          commit('updateSpotlight', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeLandingPage)
        .then((response) => {
          commit('updateLandingPage', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedPages += 1;
          this.state.loadedApi += 1;
        });
      // axios.get(routes.postTypeCampusGridPiece)
      //   .then((response) => {
      //     commit('updateCampusGridPiece', response.data);
      //   })
      //   .catch((error) => {
      //     this.state.errored = true;
      //   })
      //   .finally(() => {
      //     this.state.loadedApi += 1;
      //   });
      axios.get(routes.postTypeAcademicDates)
        .then((response) => {
          commit('updateAcademicDates', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeReminder)
        .then((response) => {
          commit('updateReminder', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeFastFact)
        .then((response) => {
          commit('updateFastFacts', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeHomeIntro)
        .then((response) => {
          commit('updateHomeIntro', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypePage)
        .then((response) => {
          commit('updatePage', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedPages += 1;
          this.state.loadedApi += 1;
        });
      axios.get(routes.postTypeToday)
        .then((response) => {
          commit('updateToday', response.data);
        })
        .catch((error) => {
          this.state.errored = true;
        })
        .finally(() => {
          this.state.loadedApi += 1;
        });
    },
  },
});
